"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const dynamicLoad_1 = require("../../dynamicLoad");
const initializer_1 = require("../../initializer");
function Routes(props) {
    const onLogin = (data) => {
        location.replace(props.mainRouteToRedirect);
    };
    return ((0, jsx_runtime_1.jsxs)(dynamicLoad_1.BaseRoutes, { ...props, children: [props.componentDRLogin && (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: "/dr-agent-login", component: props.componentDRLogin }, "dr-agent-login"), props.componentFakeLogin && ((0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: "/login", component: () => ((0, jsx_runtime_1.jsx)(props.componentFakeLogin, { doLogin: initializer_1.Authenticator.login, doPasswordPosition: initializer_1.Authenticator.getPasswordPositions, onLogin: onLogin })) }, "login")), props.componentAssistedLogin && (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: "/assisted-login", component: props.componentAssistedLogin }, "assisted-login")] }));
}
exports.Routes = Routes;
//# sourceMappingURL=routesCC.js.map